$(document).ready(function(){

    $(".js-open-form").colorbox({className: "colorbox-cleared" });
    $(".gallery-section .list a").colorbox({rel: '.gallery-section .list a', maxWidth:'95%', maxHeight:'95%'});

    $('.main-slider').owlCarousel({
        loop:true,
        margin: 0,
        nav:true,
        items: 1
    })

    $('.js-nav-toggle').click(function() {
        $('.navbar ul').toggleClass('opened');
        return false;
    });
    $(document).mouseup(function(e) {
        var $target = $(e.target);
        if ($target.closest(".js-nav-toggle").length == 0) {
            $(".navbar ul").removeClass("opened");
        }
    });
    $( window ).resize(function() {
        $(".navbar ul").removeClass('opened');
    });


});
